import { mapValues } from 'lodash';
import { setIn } from 'icepick';

/**
 * Version 3 migrations for the event website.
 * - Add sort.selectedSortOrder field to sessions widget
 */
export default function v3(website) {
  return {
    ...website,
    eventVersion: 3,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'Sessions' && !layoutItem.config.sort) {
        return setIn(layoutItem, ['config', 'sort'], {
          selectedSortOrder: ['startDate', 'startTime', 'category']
        });
      }
      return layoutItem;
    })
  };
}
